import { render, staticRenderFns } from "./GraficoPizza.vue?vue&type=template&id=1e1f5b40&"
import script from "./GraficoPizza.vue?vue&type=script&lang=js&"
export * from "./GraficoPizza.vue?vue&type=script&lang=js&"
import style0 from "./GraficoPizza.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports